import Modal from "../lib/modals";

export default class CtaHero {
  constructor(selector) {
    this.el = document.querySelector(selector);

    if (!this.el) {
      return false;
    }

    this.modalEl = document.querySelector(this.el.getAttribute('data-belongsTo'));
    this.modal = new Modal(this.modalEl);
    this.modalToggleBtn = this.el.querySelector('[data-target="modal-button"]');

    // console.log(this.modalToggleBtn);
    // console.log(this.modalEl);
    // this.modal.open();
    // console.log(this);

    if (this.modalEl && this.modal && this.modalToggleBtn) {
      this.init();
    }
  }

  init() {
    this.modalToggleBtn.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(evt) {
    evt.preventDefault();

    this.modalEl.setAttribute('aria-hidden', 'false');
  }
}
